import { useState } from 'react';

import { useUpdateEffect } from 'usehooks-ts';

import { apiDeleteFromCart } from '../constants';
import usePost from './usePost';
import useWriteCartData from './useWriteCartData';

const useDeleteFromCart = (storedCartId, isEdit = false) => {
  const [itemIdsToDelete, setItemIdsToDelete] = useState(null);
  const [formattedData, setFormattedData] = useState(null);
  const { data, status, executePost, resetPost } = usePost(apiDeleteFromCart(), formattedData);

  const { setCartDataToWrite } = useWriteCartData();

  // 3 states : null/true/false
  const [isDeleteConfirmed, setIsDeleteConfirmed] = useState(null);
  const [deleteConfirmMessage, setDeleteConfirmMessage] = useState(null);

  useUpdateEffect(() => {
    // confirmation is not confirmed, we dont proceed and reset the post
    if (deleteConfirmMessage != null && isDeleteConfirmed !== true) {
      resetPost();
      return;
    }

    const formattedDataForDelete = formatDeleteCartData(storedCartId, itemIdsToDelete);
    if (deleteConfirmMessage != null && isDeleteConfirmed === true) {
      resetPost();
      formattedDataForDelete['confirmed'] = true;
    }
    setFormattedData(formattedDataForDelete);
  }, [itemIdsToDelete, isDeleteConfirmed]);

  useUpdateEffect(() => {
    // This can happen when react reloads state
    if (itemIdsToDelete !== null) {
      executePost();
    }
  }, [formattedData]);

  useUpdateEffect(() => {
    // react reload
    if (data == null) return;

    setCartDataToWrite(data.cart ?? data); // for retrocompat
    setIsDeleteConfirmed(null);
    setDeleteConfirmMessage(data.confirm_message ?? null);
  }, [status]);

  return { setItemIdsToDelete, status, deleteConfirmMessage, isDeleteConfirmed, setIsDeleteConfirmed };
};

const formatDeleteCartData = (storedCartId, itemIdsToDelete) => {
  const formattedData = getInitialFormattedData(storedCartId);
  formattedData.item_ids = itemIdsToDelete;
  return formattedData;
};

const getInitialFormattedData = storedCartId => {
  return {
    order_id: storedCartId,
    item_ids: [],
  };
};

export default useDeleteFromCart;
